import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { CalendarCheckIcon, HouseIcon, ListBulletsIcon } from '@phosphor-icons/react';
import { BottomNav } from '@/components/BottomNav';
import { ChatButton } from '@/features/chat/ChatButton';
import { useTenant } from '@/features/tenant/context';
import { env } from '@/lib/env';

export function ClientLayout() {
  const tenant = useTenant();
  const base = `/s/${tenant.slug}`;
  // The booking sheet is a separate chunk; fetch it while the visitor reads the page.
  useEffect(() => {
    const warm = () => void import('@/pages/client/BookingFlowPage');
    if ('requestIdleCallback' in window) {
      const id = requestIdleCallback(warm, { timeout: 4000 });
      return () => cancelIdleCallback(id);
    }
    const id = setTimeout(warm, 1500);
    return () => clearTimeout(id);
  }, []);
  return (
    <>
      <Outlet context={{ tenant }} />
      {env.chatTenants.includes(tenant.slug) ? <ChatButton tenant={tenant} /> : null}
      <BottomNav
        label="Разделы"
        items={[
          { to: base, label: 'Главная', icon: HouseIcon, end: true, match: (p) => p === `${base}/booking` },
          { to: `${base}/services`, label: 'Услуги', icon: ListBulletsIcon },
          { to: `${base}/my`, label: 'Моя запись', icon: CalendarCheckIcon, match: (p) => p.startsWith(`${base}/booking/`) },
        ]}
      />
    </>
  );
}
